import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { configureStore } from '@reduxjs/toolkit'
import 'bootstrap/dist/css/bootstrap.min.css'
import './amplify'
import rootReducer from './reducers'
import App from './containers/app'

const store = configureStore({ reducer: rootReducer })

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
)
